import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './Card.module.scss.js';

function Card(_ref) {
  var children = _ref.children,
    className = _ref.className,
    dataTestId = _ref.dataTestId;
  return /*#__PURE__*/React.createElement("article", {
    className: classNames(styles.card, className),
    id: dataTestId
  }, children);
}
Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};
Card.defaultProps = {
  children: null,
  className: '',
  dataTestId: null
};

export { Card as default };
